import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { ITranslationsKeyMap } from '@modules/i18n/types';

export function getTranslationKeys(): ComputedRef<ITranslationsKeyMap> {
  return computed(() => ({
    admin: {
      partners: {
        view_partner: {
          tabs: {
            main_data: {
              tab_name: 'MAIN_TAB',
              name: 'MAIN_NAME',
              surname: 'MAIN_SURNAME',
              username: 'MAIN_USERNAME',
              birthday: 'MAIN_BIRTHDAY',
              site_url: 'MAIN_SITE_URL',
              status_label: 'MAIN_STATUS_LABEL',
              status: 'MAIN_STATUS',
            },
            contact_information: {
              tab_name: 'CONTACT_TAB',
              email: 'CONTACT_EMAIL',
              telegram: 'CONTACT_TELEGRAM',
              ms_teams: 'CONTACT_MS_TEAMS',
              whatsapp: 'CONTACT_WHATSAPP',
              phone_number: 'CONTACT_PHONE',
              agree_receive_emails: 'CONTACT_AGREE_RECEIVE_EMAILS',
            },
            offer: {
              tab_name: 'OFFER_TAB_NAME',
              about_affiliate: 'OFFER_ABOUT',
            },
          },
          button_view_parter: 'BUTTON_VIEW',
          button_back: 'BUTTON_BACK',
          header: 'HEADER',
          status_text_approved: 'STATUS_APPROVED',
          status_text_denied: 'STATUS_DENIED',
          status_text_awaiting: 'STATUS_AWAITING',
        },
      },
    },
  }));
}
